<div class="main">
  <div class="container d-flex flex-column justify-content-center align-items-center" style="width: 600px;">
    <div class="d-flex status-check" *ngIf="hasPendingProfile()">
      <img src="../../../../../../assets/images/icon/warning-org.svg" alt="">
      <span>Thông tin chưa cập nhật trên Trung tâm lưu ký chứng khoán</span>
    </div>
    <div class="d-flex">
      <form class="info-form" [formGroup]="editForm">
        <div class="row">
          <div class="form-group col-12">
            <label class="font-bold">{{'Số điện thoại cũ' | translate}}
              <span class="required">*</span>
            </label>
            <div class="d-flex justify-content-between align-items-center">
              <div class="mr-3">
                <input type="text" class="form-control custom-disabled  
                  phone-postal" formControlName="phonePostalOld" style="width: 100px;">
              </div>
              <input-number formControlName="currentPhone" placeholder="SĐT hiện tại"  [isSeparate]="false">
              </input-number>
            </div>
            <app-error-text [isDisplay]="isSaved && editForm.get('currentPhone')?.errors?.required"
              [message]="('Phone cũ' | translate) + (' bắt buộc nhập' | translate)">
            </app-error-text>
            <app-error-text [isDisplay]="isSaved && errors.currentPhone"
              [message]="('Phone cũ không đúng' | translate)">
            </app-error-text>
          </div>
          <div class="form-group w-100">
            <div class="row">
              <div class="col-6 d-flex align-items-center">
                <input class="form-control mr-3" type="radio" name="isZalo" formControlName="isZalo" [value]="false"
                  style="width: 20px;">
                <span style="font-size: 14px;">Nhận tin nhắn SMS</span>
              </div>
              <div class="col-6 d-flex align-items-center">
                <input class="form-control mr-3" type="radio" name="isZalo" formControlName="isZalo" [value]="true"
                  style="width: 20px;">
                <span style="font-size: 14px;">Nhận tin nhắn qua Zalo</span>
              </div>
            </div>
          </div>
          <div class="form-group col-12">
            <label class="font-bold">{{'Số điện thoại mới' | translate}}
              <span class="required">*</span>
            </label>
            <div class="d-flex justify-content-between align-items-center">
              <div class="mr-3">
                <input type="text" class="form-control custom-disabled  
                phone-postal" value="VN (+84)" *ngIf="!editForm.value.isZalo">
                <dropdown [value]="editForm.get('postalPhone').value" [list]="phonePostals"
                  (result)="changePhonePostal($event.callingCode)" [title]="'Chọn đầu số'" [key]="'callingCode'" style="width: 100px;"
                  [field]="'name'" *ngIf="editForm.value.isZalo">
                </dropdown>
              </div>
              <input-number formControlName="newPhone" placeholder="SĐT nhận OTP SMS"  [isSeparate]="false" *ngIf="!editForm.value.isZalo">
              </input-number>

              <input-number formControlName="newPhone" placeholder="SĐT đăng ký Zalo"  [isSeparate]="false" *ngIf="editForm.value.isZalo">
              </input-number>

            </div>
            <app-error-text class="error-text" [isDisplay]="isSaved && editForm.get('newPhone')?.errors?.required"
              [message]="('product.create.required_field' | translate)">
            </app-error-text>
            <app-error-text class="error-text" [message]="('Phone không đúng định dạng' | translate)"
              [isDisplay]="isSaved && !editForm.get('newPhone')?.errors?.required && editForm.get('newPhone')?.errors?.pattern">
            </app-error-text>
          </div>
          <div class="d-flex w-100 justify-content-center">
            <button type="submit" (click)="save()" [disabled]="hasPendingProfile()"
              class="btn btn-save btn--blue btn-block">{{'Thay đổi' | translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>